import React, { useEffect } from 'react';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { excerpt } from '../../utility';
import BlogImage from '../BlogImage';
import './blogsection.css';

const BlogSection = ({
  id,
  title,
  description,
  category,
  imgUrl,
  userId,
  author,
  timestamp,
  user,
  handleDelete,
}) => {
  return (
    <div className="blogRow" key={id}>
      <div className="blogSectionImage">
        <BlogImage src={imgUrl} alt={title} className="postImg" />
      </div>
      <div className="blogSectionContent">
        <div className="tag">Technology</div>
        <div className="postTitle"> My Title </div>
        <div className="blogSectionAuthorContainer">
          <div className="postAuthor">Author</div>
          <div className="postDate"> May 20, 2022</div>
        </div>
        <div class="postDesc">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </div>
        <div className="linkReadMore">
          <Link to={`/detail/${id}`}>
            <button className="buttonReadMore">Read More</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
